if (!customElements.get('collection-load-more')) {
  customElements.define(
    'collection-load-more',
    class CollectionLoadMore extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-load-more-button]');
        this.buttonLabel = this.querySelector('[data-load-more-label]');
        this.status = this.querySelector('[data-load-more-status]');
        this.progress = this.querySelector('[data-load-more-progress]');
        this.currentCount = Number(this.dataset.currentCount || 0);
        this.totalCount = Number(this.dataset.totalCount || 0);
        this.nextUrl = this.dataset.nextUrl;
        this.sectionId = this.dataset.sectionId;

        this.button?.addEventListener('click', this.onClick.bind(this));
      }

      onClick() {
        if (!this.nextUrl || this.button?.disabled) return;

        this.setLoading(true);

        fetch(this.getSectionUrl(this.nextUrl))
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const currentGrid = document.getElementById('product-grid');
            const nextGridItems = html.querySelectorAll('#product-grid > .grid__item');
            const nextLoadMore = html.querySelector('collection-load-more');
            const nextButton = nextLoadMore?.querySelector('[data-load-more-button]');
            const nextStatus = nextLoadMore?.querySelector('[data-load-more-status]');
            const nextProgress = nextLoadMore?.querySelector('[data-load-more-progress]');
            const currentPagination = document.querySelector('.pagination-wrapper');
            const nextPagination = html.querySelector('.pagination-wrapper');

            nextGridItems.forEach((item) => currentGrid.appendChild(document.importNode(item, true)));
            if (currentPagination && nextPagination) {
              currentPagination.replaceWith(document.importNode(nextPagination, true));
            }

            if (nextLoadMore?.dataset.nextUrl) {
              this.nextUrl = nextLoadMore.dataset.nextUrl;
              this.dataset.nextUrl = this.nextUrl;
              this.currentCount = Number(nextLoadMore.dataset.currentCount || this.currentCount + nextGridItems.length);
              this.totalCount = Number(nextLoadMore.dataset.totalCount || this.totalCount);
              this.dataset.currentCount = this.currentCount.toString();
              this.dataset.totalCount = this.totalCount.toString();
              this.dataset.nextCount = nextLoadMore.dataset.nextCount || '';
              this.updateStatus(nextStatus);
              this.updateProgress(nextProgress);
              if (this.button && nextButton) {
                this.button.dataset.label = nextButton.dataset.label || nextButton.textContent.trim();
              }
              this.setLoading(false);
              return;
            }

            this.currentCount = this.totalCount || this.currentCount + nextGridItems.length;
            this.dataset.currentCount = this.currentCount.toString();
            this.updateStatus(nextStatus);
            this.updateProgress(nextProgress);
            this.button?.remove();
          })
          .catch(() => {
            this.setLoading(false);
          });
      }

      getSectionUrl(url) {
        const sectionUrl = new URL(url, window.location.origin);
        sectionUrl.searchParams.set('section_id', this.sectionId);
        return sectionUrl.toString();
      }

      updateStatus(nextStatus) {
        if (!this.status) return;

        if (nextStatus) {
          this.status.innerHTML = nextStatus.innerHTML;
          return;
        }

        const current = this.status.querySelector('[data-load-more-current]');
        const total = this.status.querySelector('[data-load-more-total]');
        if (current) current.textContent = this.currentCount.toString();
        if (total && this.totalCount) total.textContent = this.totalCount.toString();
      }

      updateProgress(nextProgress) {
        if (!this.progress) return;

        if (nextProgress) {
          this.progress.style.setProperty(
            '--tf-load-progress',
            nextProgress.style.getPropertyValue('--tf-load-progress') || '100%'
          );
          return;
        }

        const percent = this.totalCount ? Math.min((this.currentCount / this.totalCount) * 100, 100) : 100;
        this.progress.style.setProperty('--tf-load-progress', `${percent}%`);
      }

      setLoading(isLoading) {
        if (!this.button) return;

        this.button.disabled = isLoading;
        this.button.setAttribute('aria-busy', isLoading.toString());
        const label = isLoading ? this.button.dataset.loadingLabel : this.button.dataset.label;
        if (this.buttonLabel) {
          this.buttonLabel.textContent = label;
        } else {
          this.button.textContent = label;
        }
      }
    }
  );
}
